//hack to allow mobile users to open navigation dropdown without redirecting to the target page intended for desktop users
export function onMobileDropdownClick(event){
  if (window.innerWidth < 1200) {
    event.stopPropagation();
    event.preventDefault();
  }
}